import {getQueryString} from "../../../../domain/url-provider";
import {getHiddenDataString} from "../../../../domain/hidden-data-provider";
import {ProductCompareUnion, ProductCompareWrapper} from "../interfaces";

export const MAX_ITEMS = 4;

export const parseDocumentIDs = (): number[] => {
    const qs = getQueryString()['ids'];
    if(!qs) return [];

    const set: Set<number> = new Set();

    const parts = qs.split('-');
    for(const part of parts){
        const id = Number(part) || 0;
        if(id === 0) continue;
        set.add(id);
    }

    return Array.from(set);
};

export const getHiddenData = (documentIDs: number[]) : ProductCompareWrapper|null => {
    const strData = getHiddenDataString('compare-servers-data');
    if(!strData) return null;

    try{
        const dataWrap = JSON.parse(strData) as ProductCompareWrapper;
        return formatData(dataWrap,documentIDs);
    }
    catch (ex){
        return null;
    }
};

export const formatData = (dataWrap: ProductCompareWrapper,documentIDs: number[]): ProductCompareWrapper|null => {
    if (!dataWrap) return dataWrap;

    let _unionList = [] as ProductCompareUnion[];

    dataWrap.productCompareUnionList.forEach(function (l, i) {
        if(documentIDs.includes(l.documentID))
            _unionList.push(l);
    });
    dataWrap.productCompareUnionList = _unionList;
    return  dataWrap;
}